//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/Builder.js";
import "../no/SelectFace.js";
import "../no/RegionPointList.js";
import "../no/SelectObject.js";
import "../no/ObjectList.js";
let d=[[[1,"Face",0,"SelectFace",0],[0,"HideOriginal",1,0],[1,"Region",0,"RegionPointList",0]],[[["targetFace"],"SnipSurfaceIntoPatches",{},1,0],[["targetFace","allCurves"],"CreateRegionsPreview",{},2,0],[["targetFace","allCurves"],"DeleteInternalPatch",{},2,0],[[],"GetExtractFace",{R_:{extractFace:"Face"}},0,0],[["targetFace","numCurves","allCurves"],"GetIsoCurves",{},1,0],[["extractFace"],"DeleteExtractFace",{},1,0],[["allCurves"],"DeleteIsoCurve",{},1,0]],[]];
SPLM.GeometricUtilities.SnipIntoPatchesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.SnipIntoPatchesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;